import { tokenizeMentions } from "@shared/ui/tokenizeMentions";

import type { TargetRef } from "../SettingsPayload";

import { isTargetRef } from "./isTargetRef";

/**
 * 指示本文から対象（{@link TargetRef}）を取り出す。出現順で重複を除く。
 *
 * 本文が対象を決めるのがこの設計の要で、対象を別欄で選ばせない。`Assignment.targets` は
 * この結果を保存したもので、実行制御が散文を解析しないで済むようにする。
 *
 * 表記の読み取りは ui-kit が持つ。**接頭辞での濾しはここが持つ。** 読む側は参照の中身を
 * 解さないので、対象として通すかどうかを知っているのはドメインの側だけである。
 */
export function parseMentions(instruction: string): TargetRef[] {
    const seen = new Set<TargetRef>();
    const out: TargetRef[] = [];
    for (const token of tokenizeMentions(instruction)) {
        if (token.kind !== "mention") continue;
        if (!isTargetRef(token.ref)) continue;
        if (seen.has(token.ref)) continue;
        seen.add(token.ref);
        out.push(token.ref);
    }
    return out;
}
